import { useState } from "react";
import { Axes, ChartSvg, LinearScale, M, NiceDomain, NiceTicks, SERIES, Tooltip, TopRoundedBar, W, H, type TooltipState } from "./ChartKit";

// Counts per category for each group (rows = groups), drawn side by side with a 2px gap.
export function GroupedBarChart({ categories, counts }: { categories: string[]; counts: number[][] }) {
  const [tip, setTip] = useState<TooltipState | null>(null);
  const [, top] = NiceDomain(0, Math.max(...counts.flat()));
  const y = LinearScale([0, top], [H - M.bottom, M.top]);
  const band = (W - M.left - M.right) / categories.length;
  const barW = (band * 0.6) / counts.length;
  return (
    <div className="relative">
      <ChartSvg label="Grouped bar chart of counts by category and group" onLeave={() => setTip(null)}>
        <Axes xTicks={[]} yTicks={NiceTicks(0, top)} x={(v) => v} y={y} xLabel="" yLabel="Count" />
        {categories.map((cat, c) => {
          const start = M.left + band * c + band * 0.2;
          return (
            <g key={cat}>
              {counts.map((row, g) => {
                const x = start + g * barW + 1;
                return (
                  <path
                    key={g} d={TopRoundedBar(x, y(row[c]), barW - 2, H - M.bottom - y(row[c]))} className={SERIES[g].fill}
                    onMouseEnter={() => setTip({ x: x + barW / 2, y: y(row[c]), lines: [`${SERIES[g].name} · ${cat}`, `${row[c]} of ${row.reduce((s, v) => s + v, 0)} (${Math.round((row[c] / row.reduce((s, v) => s + v, 0)) * 100)}%)`] })}
                  />
                );
              })}
              <text x={start + band * 0.3} y={H - M.bottom + 16} textAnchor="middle" className="fill-[#5C5C66] dark:fill-[#9A9A9A] text-[10px]">{cat}</text>
            </g>
          );
        })}
      </ChartSvg>
      <Tooltip tip={tip} />
    </div>
  );
}
